import React, { Component } from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import UploadImage from "../../base/features/blocks/UploadImage";
import SimpleHeader from "../../base/features/blocks/SimpleHeader";
import Intro from "./intro/Intro";
import CreditCard from "./CreditCard/CreditCard";
import { FiChevronDown } from "react-icons/fi";
import Geo from "./geo/Geo";
import TermsModal from "../../base/features/blocks/TermsModal";
import CategoriesModal from "../blocks/CategoriesModal";
import { creactShop, registeredShop } from "./services";
import Swal from "sweetalert2";
import { Redirect } from "react-router";
import Empty from "../../base/features/blocks/Empty";
import { Link } from "react-router-dom";

class AddShop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      introModal: true,
      geoModal: false,
      termsModal: false,
      categoryModal: false,
      images: [],
      shopName: "",
      des: "",
      managerName: "",
      managerLastName: "",
      cardNumber: "",
      selectedState: null,
      selectedCity: null,
      category: null,
      producer: false,
      personalized_product: false,
      pending: false,
      registeredShopUid: "",
      pageHeader: "ایجاد فروشگاه جدید",
    };
  }
  componentDidMount() {
    this.getShop();
  }
  addShop() {
    if (!this.state.shopName) {
      Swal.fire({
        title: "نام فروشگاه الزامی است",
        icon: "info",
        confirmButtonText: "تایید",
        timer: 3000,
      });
      return;
    }
    if (!this.state.managerName) {
      Swal.fire({
        title: "نام مدیر الزامی است",
        icon: "info",
        confirmButtonText: "تایید",
        timer: 3000,
      });
      return;
    }
    if (!this.state.managerLastName) {
      Swal.fire({
        title: "نام خانوادگی مدیر الزامی است",
        icon: "info",
        confirmButtonText: "تایید",
        timer: 3000,
      });
      return;
    }
    if (!this.state.selectedCity || !this.state.selectedState) {
      Swal.fire({
        title: "محل فعالیت فروشگاه الزامی است",
        icon: "info",
        confirmButtonText: "تایید",
        timer: 3000,
      });
      return;
    }
    if (!this.state.category) {
      Swal.fire({
        title: "دسته بندی فروشگاه الزامی است",
        icon: "info",
        confirmButtonText: "تایید",
        timer: 3000,
      });
      return;
    }
    if (this.state.cardNumber.length !== 16) {
      Swal.fire({
        title: "شماره کارت بانکی 16 باشد",
        icon: "info",
        confirmButtonText: "تایید",
        timer: 3000,
      });
      return;
    }
    if (this.state.images.length === 0) {
      Swal.fire({
        title: "نشانه فروشگاه الزامی است",
        icon: "info",
        confirmButtonText: "تایید",
        timer: 3000,
      });
      return;
    }
    var params = {
      title: this.state.shopName,
      des: this.state.des,
      admin_first_name: this.state.managerName,
      admin_last_name: this.state.managerLastName,
      city: this.state.selectedCity.uid,
      state: this.state.selectedState.uid,
      category: this.state.category.uid,
      cover: this.state.images[0].uid,
      payment_config: {
        card: this.state.cardNumber,
      },
      config: {
        personalized_product: this.state.personalized_product,
        producer: this.state.producer,
      },
    };
    this.setState({ pending: true });
    creactShop(params, this.state.registeredShopUid).then((items) => {
      if (items.response && items.response.status === 400) {
        if (items.response.data.errors.payment_config) {
          this.setState(
            {
              cardError: items.response.data.errors.payment_config.card,
            },
            () => {
              document.getElementById("cardBox").scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "nearest",
              });
            }
          );
        }
        if (items.response.data.errors.title) {
          this.setState({ titleError: items.response.data.errors.title }, () =>
            document.getElementById("shopName").scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            })
          );
        }
      } else {
        if (items) {
          this.setState({
            newShopUid: items.uid,
            pending: false,
            redirect: true,
          });
        }
      }
      this.setState({ pending: false });
    });
  }

  getShop() {
    registeredShop().then((items) => {
      items &&
        items.uid &&
        this.setState({
          pageHeader: "ویرایش فروشگاه جدید",
          registeredShopUid: items.uid,
          shopName: items.title,
          des: items.des,
          managerName: items.admin_first_name,
          managerLastName: items.admin_last_name,
          cardNumber: items.payment_config.card,
          images: [items.cover],
          category: items.category,
          selectedCity: items.city,
          selectedState: items.state,
          producer: items.config.producer,
          personalized_product: items.config.personalized_product,
        });
    });
  }
  render() {
    return localStorage.getItem(`${window.location.hostname}_token`) ? (
      <div className="container-fluid">
        {this.state.redirect && (
          <Redirect
            push
            to={`/dashboard/${this.state.newShopUid}/`}
            // to={`/dashboard/${this.state.newShopUid}/activation`}
          />
        )}
        <Intro
          introModal={this.state.introModal}
          changeModal={(e) => this.setState({ introModal: e })}
        />
        <SimpleHeader text={this.state.pageHeader} />
        <body style={{ marginTop: "80px", marginBottom: "30px" }}>
          <div className="row mx-0 px-0">
            <div className="col-12 px-0">
              <p className="fw-bold fs-5">نشانه (لوگو)</p>
            </div>
            <div className="col-4 px-0">
              <UploadImage
                singleMedia={true}
                images={this.state.images}
                updateImages={(images) => this.setState({ images: images })}
              />
            </div>
            {this.state.images.length === 0 && (
              <div className="col-8 px-2 py-2 small text-secondary">
                * بهتر است عکس نشانه بدون فریم و نوشته باشد.
                <br />* اگر نشانه ندارید میتوانید از عکس محصولاتتان استفاده
                کنید.
              </div>
            )}
            {this.state.images.length > 0 &&
              this.state.images.map((image, i) => (
                <div
                  className="col-4 p-1 position-relative text-center rounded14 "
                  style={{ height: "100px" }}
                >
                  <img
                    alt="camera"
                    className="w-100 h-100 img-cover rounded14"
                    src={image.file}
                  />
                  <RiCloseCircleFill
                    onClick={() => {
                      var new_medias = this.state.images;
                      new_medias.splice(i, 1);
                      this.setState({ images: new_medias });
                    }}
                    className="position-absolute text-muted"
                    style={{ top: "7px", right: "7px" }}
                    size="25"
                  />
                </div>
              ))}
          </div>
          <div className="row mx-0 mt-4">
            <div className="col-12 px-0">
              <input
                id="shopName"
                className={`form-control p-3 rounded14 fw-bold bg-image-left ${
                  this.state.titleError ? "is-invalid" : ""
                }`}
                placeholder="نام فارسی فروشگاه"
                value={this.state.shopName}
                onChange={(e) =>
                  this.setState({ shopName: e.target.value, titleError: null })
                }
              />
              <p className="small text-secondary mt-2 px-3">
                *بعد از ثبت فروشگاه می توانید شناسه فروشگاه خود را تعیین کنید.
              </p>
              {this.state.titleError && (
                <span className="text-danger small pe-3">
                  {this.state.titleError[0].message}
                </span>
              )}
            </div>
            <div className="col-12 px-0 mt-4">
              <textarea
                rows="4"
                className="form-control p-3 rounded14 fw-bold"
                placeholder="معرفی (اختیاری)"
                value={this.state.des}
                onChange={(e) => this.setState({ des: e.target.value })}
              />
            </div>
            <div className="col-12 px-0 mt-4">
              <input
                className="form-control p-3 rounded14 fw-bold"
                placeholder="نام مدیر (به فارسی)"
                value={this.state.managerName}
                onChange={(e) => {
                  /^[آ-ی ]*$/.test(e.target.value) &&
                    this.setState({ managerName: e.target.value });
                }}
              />
            </div>
            <div className="col-12 px-0 mt-4">
              <input
                className="form-control p-3 rounded14 fw-bold"
                placeholder="نام خانوادگی مدیر (به فارسی)"
                value={this.state.managerLastName}
                onChange={(e) =>
                  /^[آ-ی ]*$/.test(e.target.value) &&
                  this.setState({ managerLastName: e.target.value })
                }
              />
            </div>
            <CreditCard
              cardError={this.state.cardError}
              cardNumber={this.state.cardNumber}
              cardNumberChange={(e) =>
                this.setState({ cardNumber: e, cardError: null })
              }
            />
            <div
              className="col-12 p-3 mt-3 rounded14 border d-flex justify-content-between"
              onClick={() => this.setState({ categoryModal: true })}
            >
              <span className="fw-bold">
                {this.state.category ? this.state.category.title : "دسته بندی"}
              </span>
              <FiChevronDown size={25} />
            </div>

            <CategoriesModal
              categoryModal={this.state.categoryModal}
              changeModal={(e) => this.setState({ categoryModal: e })}
              category={this.state.category}
              categoryChange={(e) => this.setState({ category: e })}
            />

            <div
              className="col-12 p-3 mt-4 rounded14 border d-flex justify-content-between"
              onClick={() => this.setState({ geoModal: true })}
            >
              <span className="fw-bold">
                {this.state.selectedCity && this.state.selectedState
                  ? this.state.selectedState.name +
                    " - " +
                    this.state.selectedCity.name
                  : "محل فعالیت"}
              </span>
              <FiChevronDown size={25} />
            </div>
            {this.state.geoModal && (
              <Geo
                geoModal={this.state.geoModal}
                changeModal={(e) => this.setState({ geoModal: e })}
                selectedState={this.state.selectedState}
                stateChange={(e) =>
                  this.setState({ selectedState: e, selectedCity: null })
                }
                cityChange={(e) => this.setState({ selectedCity: e })}
              />
            )}

            <div className="col-12 d-flex justify-content-between py-3">
              <span className="fw-bold ms-3">
                همه ی کالاها را خودم تولید میکنم.
              </span>
              <input
                className="form-check-input"
                value={this.state.producer}
                checked={this.state.producer}
                onChange={() =>
                  this.setState({
                    producer: !this.state.producer,
                  })
                }
                type="checkbox"
              />
            </div>
            {this.state.producer && (
              <div className="col-12 d-flex justify-content-between py-3">
                <span className="fw-bold ms-3">
                  امکان تولید محصول سفارشی را دارم.
                </span>
                <input
                  className="form-check-input"
                  value={this.state.personalized_product}
                  checked={this.state.personalized_product}
                  onChange={() =>
                    this.setState({
                      personalized_product: !this.state.personalized_product,
                    })
                  }
                  type="checkbox"
                />
              </div>
            )}

            {this.state.termsModal && (
              <TermsModal
                termId={"new-shop"}
                termsModal={this.state.termsModal}
                changeModal={(e) => this.setState({ termsModal: e })}
              />
            )}
            <div className="col-12 px-0 align-self-center mt-3">
              <div className="fs-7 text-center fw-bolder px-3 py-2-3">
                {"ادامه به معنی قبول تمامی "}
                <span
                  onClick={() => {
                    this.setState({ termsModal: true });
                  }}
                  className="color-main"
                >
                  قوانین و مقررات{" "}
                </span>
                {"گیتی مارکت است"}
              </div>
              <button
                disabled={
                  this.state.pending ||
                  this.state.images.length === 0 ||
                  !this.state.shopName ||
                  !this.state.managerName ||
                  !this.state.managerLastName ||
                  !this.state.cardNumber ||
                  this.state.cardNumber.length !== 16 ||
                  !this.state.category ||
                  !this.state.selectedCity ||
                  !this.state.selectedState
                }
                onClick={() => this.addShop()}
                className="btn py-2-3 w-100 rounded28 bg-color-main text-white fw-bold bg-disabled"
              >
                {this.state.pending ? (
                  <span className="spinner-border spinner-border-sm text-white align-middle"></span>
                ) : (
                  "ادامه"
                )}
              </button>
            </div>
          </div>
        </body>
      </div>
    ) : (
      <div className="text-center">
        <div className="w-75 mx-auto">
          <Empty text="ابتدا باید وارد شوید" />
          <Link to="/login">
            <button className="btn border rounded28 px-4 py-2 small color-main">
              ورود
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default AddShop;
